/**
 * Public Sterling types.
 *
 * The package intentionally keeps the public surface small: a Theme,
 * an OpcoId, and the manifest types. Component props are exported per
 * component file.
 */
export const OPCOS = [
    { id: 'silver-falls', name: 'Silver Falls', swatch: '#2C5F7C' },
    { id: 'sportworks', name: 'Sportworks', swatch: '#FFC700' },
    { id: 'omni', name: 'Omni CleanAir', swatch: '#004890' },
    { id: 'birdbuffer', name: 'Bird Buffer', swatch: '#502080' },
    { id: 'citc', name: 'CITC', swatch: '#000000' },
];
//# sourceMappingURL=types.js.map